export default __webpack_public_path__ + "019ea83bfd23cc8b435e7c8f809f82e7.png";